import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function CustomDialog({ open, handleClose, title, children, onAnswer = () => { }, 
yes = 'כן', no = 'לא', onOk = false, onCancel = false,
maxWidth = 'md', fullWidth = true, style = null,
nameWindow = 'CustomDialog', width = { minWidth: '400px', maxWidth: '1200px' }
 }) {
  useEffect(() => {
    const handleRowSubmit = () => {
      // פעולות לביצוע לאחר סבמיט
      handleClose(false)
    };

    window.addEventListener(nameWindow, handleRowSubmit);

    return () => {
      window.removeEventListener(nameWindow, handleRowSubmit);
    };
  }, []);

  const handleAnswer = (answer) => {
    onAnswer(answer);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={!style && { '& .MuiDialog-paper': width }}
    >
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" style={{ flexGrow: 1, textAlign: 'right' }}>
            {title}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      {(onOk || onCancel) &&
        <DialogActions>
          {
            onCancel &&
            <Button onClick={() => handleAnswer(false)} color="primary">
              {no}
            </Button>
          }
          {onOk &&
            <Button onClick={() => handleAnswer(true)} color="secondary">
              {yes}
            </Button>
          }
        </DialogActions>
      }
    </Dialog>
  );
}

export default CustomDialog;
